<template>
    <div>
        <q-input
                v-model="content"
                type="textarea"
                placeholder="Add a note..."
                :loading="isLoading"
                v-bind="$attrs"
                @keydown.enter.prevent="add"
        />
        <div class="text-center q-mt-md">
            <q-btn icon="fa fa-plus" label="Save Note" :disable="!content" @click="add"/>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { PostNote } from '@/type';
import { HasTaskMixin } from '@/mixins';
import { add } from './post-note';

interface Data {
  task: Promise<PostNote>|null,
  content: string,
}

export default defineComponent({
  emits: ['added'],
  mixins: [HasTaskMixin],
  props: {
    postId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
      content: '',
    };
  },
  methods: {
    add() {
      if (!this.content) return;
      this.task = add(this.postId, this.content);
      this.task.then((note: PostNote) => {
        this.$emit('added', note);
        this.content = '';
      });
    },
  },
});
</script>
